import { put} from '../Services/http';
import { FAVOURITE_LIST_RECEIVE } from '../bevegoConstants';

const rootRoute = '/api/favouritelist';

export const receive = (favouriteList) => ({
    type: FAVOURITE_LIST_RECEIVE,
    payload: favouriteList,
});

export const addOrUpdateItem = (articleNumber,) => (dispatch) => {
    return put(`${rootRoute}/addorupdate?id=${articleNumber}`)
        .then((response) => response.json())
        .then((response) => {
            if (response.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push(response.dataLayer);
            }
            if (response.isInList) {
                return response.isInList;
            }
            else {
                dispatch(receive(response))
            }
        })
};
